import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Secondary, Text } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide } from "@cinch-nx/shared-ui";
import { useMediaQuery } from "@react-hook/media-query";
import styles from "./partnerships.module.css";
export const Partnerships = (blok)=>{
    var ref;
    const { heading , body , partners  } = blok;
    const [CTA] = blok.CTA || [];
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const carouselSettings = {
        name: "about-us-partnerships",
        ariaLabels: {
            previous: "Go to previous slide",
            next: "Go to next slide"
        },
        swiperSettings: {
            spaceBetween: 78,
            slidesPerView: isDesktop ? 3 : 1
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        ...storyblokEditable(blok),
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: heading
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                name: carouselSettings.name,
                swiperSettings: carouselSettings.swiperSettings,
                customClassNames: {
                    carousel: styles.carousel
                },
                children: (ref = partners === null || partners === void 0 ? void 0 : partners.filter((image)=>{
                    return image === null || image === void 0 ? void 0 : image.filename;
                })) === null || ref === void 0 ? void 0 : ref.map((image)=>/*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.imageWrapper,
                            children: /*#__PURE__*/ _jsx("img", {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                className: styles.image
                            })
                        })
                    }, image.id))
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles.carouselControls,
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselSettings.name
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselSettings.name,
                        ariaLabels: carouselSettings.ariaLabels,
                        customClassNames: {
                            prevButton: styles.carouselNavButton,
                            nextButton: styles.carouselNavButton
                        }
                    })
                ]
            }),
            CTA ? /*#__PURE__*/ _jsx("div", {
                ...storyblokEditable(CTA),
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.buttonWrapper,
                    children: /*#__PURE__*/ _jsx(Secondary, {
                        element: "a",
                        href: CTA.url,
                        classNames: {
                            button: styles.button
                        },
                        children: CTA.text
                    })
                })
            }) : null
        ]
    });
};
export default Partnerships;
